(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-hb-bouquet]';

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '£{{amount}}');
    }

    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format((Number(cents) || 0) / 100);
  }

  function track(name, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: name,
      bouquet_offer: 'design_your_own_bouquet',
      bouquet_version: '2026-08-21'
    }, detail || {}));
  }

  function canonicalVariantKey(ids) {
    var clean = ids.map(function (id) { return String(id || '').trim(); }).filter(Boolean);
    if (clean.length !== ids.length || new Set(clean).size !== clean.length) return null;
    return clean.sort(function (left, right) {
      return left.length === right.length ? left.localeCompare(right) : left.length - right.length;
    }).join(':');
  }

  function readNativeBundleMap(root) {
    var result = { classic: new Map(), premium: new Map() };
    var source = root.querySelector('[data-native-bundle-map]');
    if (!source) return result;
    try {
      var parsed = JSON.parse(source.textContent);
      ['classic', 'premium'].forEach(function (tier) {
        (Array.isArray(parsed[tier]) ? parsed[tier] : []).forEach(function (entry) {
          var id = Number(entry.id);
          var price = Number(entry.price);
          if (!entry.key || !id || !Number.isFinite(price) || result[tier].has(entry.key)) return;
          result[tier].set(entry.key, {
            id: id,
            price: price,
            available: entry.available === true
          });
        });
      });
    } catch (error) {
      console.error('[HB flower mix] Native bundle map could not be read:', error);
    }
    return result;
  }

  function getCartSections() {
    try {
      var helper = window.Alpine && window.Alpine.store('xCartHelper');
      return helper && typeof helper.getSectionsToRender === 'function'
        ? helper.getSectionsToRender()
        : [];
    } catch (error) {
      return [];
    }
  }

  function refreshCartSections(payload, sections) {
    var updated = 0;
    if (!payload.sections || !sections.length) return updated;
    sections.forEach(function (section) {
      var element = document.querySelector(section.selector);
      var html = payload.sections[section.id];
      if (!element || !html) return;
      if (typeof window.getSectionInnerHTML === 'function') {
        var innerHtml = window.getSectionInnerHTML(html, section.selector);
        if (typeof innerHtml !== 'string') return;
        element.innerHTML = innerHtml;
      } else {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var replacement = parsed.querySelector(section.selector);
        if (!replacement) return;
        element.innerHTML = replacement.innerHTML;
      }
      updated += 1;
    });
    return updated;
  }

  async function getCart(root) {
    var response = await fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Your basket could not be confirmed. Please try again.');
    return response.json();
  }

  function updateCartCount(cart) {
    var displayCount = cart.item_count > 99 ? '99+' : String(cart.item_count);
    ['#cart-icon-bubble', '#mobile-cart-icon-bubble'].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (bubble) {
        var count = bubble.querySelector('span');
        var badge = bubble.firstElementChild;
        if (count) count.textContent = displayCount;
        if (badge) badge.classList.toggle('hidden', cart.item_count === 0);
        bubble.setAttribute('data-value', String(cart.item_count));
      });
    });
    try {
      var helper = window.Alpine && window.Alpine.store('xCartHelper');
      if (helper) helper.currentItemCount = cart.item_count;
    } catch (error) {
      // Visible cart counts have already been updated.
    }
  }

  async function openMiniCart(needsReload) {
    try {
      var miniCart = window.Alpine && window.Alpine.store('xMiniCart');
      if (!miniCart || typeof miniCart.openCart !== 'function') return false;
      if (needsReload && typeof miniCart.reLoad === 'function') {
        await Promise.resolve(miniCart.reLoad());
      }
      miniCart.openCart();
      return true;
    } catch (error) {
      return false;
    }
  }

  function BouquetBuilder(root) {
    this.root = root;
    this.classicPrice = Number(root.dataset.classicPrice);
    this.premiumPrice = Number(root.dataset.premiumPrice);
    this.giftPrice = Number(root.dataset.giftPrice);
    this.giftVariantId = root.dataset.giftVariant;
    this.giftQuantity = Number(root.dataset.giftQuantity) || 0;
    this.classicAvailable = root.dataset.classicAvailable === 'true';
    this.premiumAvailable = root.dataset.premiumAvailable === 'true';
    this.checkoutEnabled = root.dataset.checkoutEnabled === 'true';
    this.nativeBundles = readNativeBundleMap(root);
    this.isSubmitting = false;
    this.tier = this.classicAvailable ? 'classic' : (this.premiumAvailable ? 'premium' : 'classic');
    this.isReviewing = false;
    this.launchTrigger = null;
    this.activeFamily = 'ranunculus';
    this.selected = {
      ranunculus: [],
      anemone: []
    };
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-flower-card]'));
    this.storageKey = 'hb-design-bouquet:' + root.dataset.sectionId + ':v3';

    this.cache();
    this.bind();
    this.restore();
    if (this.selected.ranunculus.length === 2) {
      this.setFamilyStage('anemone', false, false);
    }
    this.render();
    track('bouquet_builder_view', {
      classic_price: this.classicPrice / 100,
      premium_price: this.premiumPrice / 100,
      classic_available: this.classicAvailable,
      premium_available: this.premiumAvailable
    });
  }

  BouquetBuilder.prototype.cache = function () {
    this.progressLabel = this.root.querySelector('[data-progress-label]');
    this.progressBar = this.root.querySelector('[data-progress-bar]');
    this.progressMessage = this.root.querySelector('[data-progress-message]');
    this.ranCount = this.root.querySelector('[data-family-count="ranunculus"]');
    this.anemoneCount = this.root.querySelector('[data-family-count="anemone"]');
    this.anemoneRequired = this.root.querySelector('[data-anemone-required]');
    this.anemoneVarietyLabel = this.root.querySelector('[data-anemone-variety-label]');
    this.tierTabs = Array.prototype.slice.call(this.root.querySelectorAll('[data-tier-tab]'));
    this.tierPanels = Array.prototype.slice.call(this.root.querySelectorAll('[data-tier-panel]'));
    this.tierStartButtons = Array.prototype.slice.call(this.root.querySelectorAll('[data-start-tier]'));
    this.familyTabs = Array.prototype.slice.call(this.root.querySelectorAll('[data-family-tab]'));
    this.familySections = Array.prototype.slice.call(this.root.querySelectorAll('[data-family-section]'));
    this.familyTabStatuses = Array.prototype.slice.call(this.root.querySelectorAll('[data-family-tab-status]'));
    this.familyActions = Array.prototype.slice.call(this.root.querySelectorAll('[data-family-action]'));
    this.familyTitles = {
      ranunculus: this.root.querySelector('[data-family-title="ranunculus"]'),
      anemone: this.root.querySelector('[data-family-title="anemone"]')
    };
    this.mobileFamilyPicks = {
      ranunculus: this.root.querySelector('[data-mobile-family-picks="ranunculus"]'),
      anemone: this.root.querySelector('[data-mobile-family-picks="anemone"]')
    };
    this.pickerPicks = {
      ranunculus: this.root.querySelector('[data-picker-picks="ranunculus"]'),
      anemone: this.root.querySelector('[data-picker-picks="anemone"]')
    };
    this.pickerStatuses = {
      ranunculus: this.root.querySelector('[data-picker-status="ranunculus"]'),
      anemone: this.root.querySelector('[data-picker-status="anemone"]')
    };
    this.pickerNextButtons = Array.prototype.slice.call(this.root.querySelectorAll('[data-picker-next]'));
    this.pickerBackButtons = Array.prototype.slice.call(this.root.querySelectorAll('[data-picker-back]'));
    this.pickerCloseButtons = Array.prototype.slice.call(this.root.querySelectorAll('[data-close-picker]'));
    this.summaryTier = this.root.querySelector('[data-summary-tier]');
    this.summaryCount = this.root.querySelector('[data-summary-count]');
    this.selectedList = this.root.querySelector('[data-selected-list]');
    this.emptyMessage = this.root.querySelector('[data-empty-message]');
    this.gift = this.root.querySelector('[data-gift]');
    this.giftStatus = this.root.querySelector('[data-gift-status]');
    this.normalValue = this.root.querySelector('[data-normal-value]');
    this.bundlePrice = this.root.querySelector('[data-bundle-price]');
    this.saving = this.root.querySelector('[data-saving]');
    this.deliveryStatus = this.root.querySelector('[data-delivery-status]');
    this.premiumSwitch = this.root.querySelector('[data-premium-switch]');
    this.cta = this.root.querySelector('[data-add-bouquet]');
    this.ctaLabel = this.root.querySelector('[data-cta-label]');
    this.status = this.root.querySelector('[data-status]');
    this.mobileBar = this.root.querySelector('[data-mobile-bar]');
    this.mobileProgress = this.root.querySelector('[data-mobile-progress]');
    this.mobilePrice = this.root.querySelector('[data-mobile-price]');
    this.mobileAction = this.root.querySelector('[data-mobile-action]');
    this.summary = this.root.querySelector('[data-summary]');
    this.startButtons = Array.prototype.slice.call(this.root.querySelectorAll('[data-start-builder]'));
    this.closeBuilderButtons = Array.prototype.slice.call(this.root.querySelectorAll('[data-close-builder]'));
    this.reviewBack = this.root.querySelector('[data-review-back]');
    this.editFamilyButtons = Array.prototype.slice.call(this.root.querySelectorAll('[data-edit-family]'));
  };

  BouquetBuilder.prototype.bind = function () {
    var self = this;

    this.cards.forEach(function (card) {
      card.addEventListener('click', function () {
        self.toggleCard(card);
      });
    });

    this.tierTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        self.chooseTier(tab.dataset.tierTab, true);
      });
    });

    this.tierStartButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.chooseTier(button.dataset.startTier, true);
        self.openBuilder(button);
        track('bouquet_tier_shortcut_clicked', {
          source: 'hero',
          tier: button.dataset.startTier
        });
      });
    });

    this.familyTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.disabled) return;
        self.openMobilePicker(tab.dataset.familyTab, tab);
      });
    });

    this.startButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.openBuilder(button);
      });
    });

    this.root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-picker-next]');
      if (!button || !self.root.contains(button)) return;
      self.continueFromPicker(button.dataset.pickerNext);
    });

    this.pickerBackButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.openMobilePicker(button.dataset.pickerBack, button);
      });
    });

    this.pickerCloseButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.closeMobilePicker(true);
      });
    });

    this.closeBuilderButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.closeMobilePicker(true);
      });
    });

    if (this.reviewBack) {
      this.reviewBack.addEventListener('click', function () {
        self.openMobilePicker('anemone', self.reviewBack);
      });
    }

    this.editFamilyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        self.openMobilePicker(button.dataset.editFamily, button);
      });
    });

    if (this.premiumSwitch) {
      this.premiumSwitch.addEventListener('click', function () {
        self.chooseTier('premium', true);
        self.isReviewing = false;
        self.setFamilyStage('ranunculus', true, false);
        self.root.classList.remove('is-review-open');
        self.root.classList.add('is-picker-open');
        self.refreshDialogState();
        self.focusPickerStart('ranunculus');
        track('bouquet_tier_shortcut_clicked', {
          source: 'classic_review',
          tier: 'premium'
        });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (!self.root.classList.contains('is-builder-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        self.closeMobilePicker(true);
      } else if (event.key === 'Tab') {
        self.trapPickerFocus(event);
      }
    });

    this.selectedList.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-remove-variant]');
      if (!remove) return;
      var card = self.cards.find(function (candidate) {
        return candidate.dataset.variantId === remove.dataset.removeVariant;
      });
      if (card) self.toggleCard(card);
    });

    this.cta.addEventListener('click', function () {
      self.submit();
    });

    this.mobileAction.addEventListener('click', function () {
      self.handleMobileAction();
    });

  };

  BouquetBuilder.prototype.requirement = function (family) {
    if (family === 'ranunculus') return 2;
    return 1;
  };

  BouquetBuilder.prototype.isMobile = function () {
    return window.matchMedia('(max-width: 749px)').matches;
  };

  BouquetBuilder.prototype.openBuilder = function (trigger) {
    if ((this.isPremium() && !this.premiumAvailable) || (!this.isPremium() && !this.classicAvailable)) {
      this.setStatus('This flower mix is temporarily unavailable while stock is refreshed.');
      return;
    }
    this.launchTrigger = trigger || this.launchTrigger;
    if (this.isComplete()) {
      this.openReview(trigger);
    } else if (this.selected.ranunculus.length < 2) {
      this.openMobilePicker('ranunculus', trigger);
    } else {
      this.openMobilePicker('anemone', trigger);
    }
    track('bouquet_builder_started');
  };

  BouquetBuilder.prototype.openMobilePicker = function (family, trigger) {
    if (family !== 'ranunculus' && family !== 'anemone') return;
    this.lastPickerTrigger = trigger || null;
    this.isReviewing = false;
    this.setFamilyStage(family, true, false);
    this.root.classList.add('is-builder-open');
    this.root.classList.add('is-picker-open');
    this.root.classList.remove('is-review-open');
    this.lockPage();
    this.refreshDialogState();
    this.focusPickerStart(family);
  };

  BouquetBuilder.prototype.openReview = function (trigger) {
    if (!this.isComplete()) return;
    this.lastPickerTrigger = trigger || this.lastPickerTrigger || null;
    this.isReviewing = true;
    this.root.classList.add('is-builder-open', 'is-review-open');
    this.root.classList.remove('is-picker-open');
    this.lockPage();
    this.refreshDialogState();
    var summary = this.summary;
    window.requestAnimationFrame(function () {
      if (!summary) return;
      summary.scrollTop = 0;
      summary.focus();
    });
    track('bouquet_review_viewed', {
      tier: this.tier
    });
  };

  BouquetBuilder.prototype.closeMobilePicker = function (restoreFocus) {
    if (!this.root.classList.contains('is-builder-open')) return;
    this.root.classList.remove('is-builder-open', 'is-picker-open', 'is-review-open');
    this.isReviewing = false;
    this.familySections.forEach(function (section) {
      section.removeAttribute('role');
      section.removeAttribute('aria-modal');
    });
    if (this.summary) {
      this.summary.removeAttribute('role');
      this.summary.removeAttribute('aria-modal');
    }
    this.familyTabs.forEach(function (tab) {
      tab.setAttribute('aria-expanded', 'false');
    });
    this.setBackgroundInert(false);
    this.unlockPage();
    if (restoreFocus && this.launchTrigger) this.launchTrigger.focus();
  };

  BouquetBuilder.prototype.lockPage = function () {
    if (this.bodyLockState) return;
    var body = document.body;
    this.bodyLockState = {
      scrollY: window.scrollY,
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width
    };
    document.documentElement.classList.add('hb-bouquet-picker-open');
    body.style.position = 'fixed';
    body.style.top = '-' + this.bodyLockState.scrollY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
  };

  BouquetBuilder.prototype.unlockPage = function () {
    if (!this.bodyLockState) return;
    var state = this.bodyLockState;
    var body = document.body;
    document.documentElement.classList.remove('hb-bouquet-picker-open');
    body.style.position = state.position;
    body.style.top = state.top;
    body.style.left = state.left;
    body.style.right = state.right;
    body.style.width = state.width;
    this.bodyLockState = null;
    window.scrollTo(0, state.scrollY);
  };

  BouquetBuilder.prototype.setBackgroundInert = function (makeInert) {
    if (!makeInert) {
      (this.inertState || []).forEach(function (item) {
        item.element.inert = item.inert;
        if (item.ariaHidden === null) item.element.removeAttribute('aria-hidden');
        else item.element.setAttribute('aria-hidden', item.ariaHidden);
      });
      this.inertState = [];
      return;
    }

    this.setBackgroundInert(false);
    var activeSection = this.isReviewing
      ? this.summary
      : this.root.querySelector('[data-family-section="' + this.activeFamily + '"]');
    var targets = Array.prototype.slice.call(this.root.querySelectorAll(
      '.hb-bouquet__announcement, .hb-bouquet__hero, .hb-bouquet__steps, .hb-bouquet__builder-header, .hb-bouquet__family-tabs, .hb-bouquet__summary, .hb-bouquet__promise, .hb-bouquet__mobile-bar'
    )).filter(function (element) {
      return element && element !== activeSection && !(activeSection && activeSection.contains(element));
    });
    this.familySections.forEach(function (section) {
      if (section !== activeSection) targets.push(section);
    });
    if (this.summary && this.summary !== activeSection && targets.indexOf(this.summary) === -1) targets.push(this.summary);
    this.inertState = targets.map(function (element) {
      var state = { element: element, inert: element.inert, ariaHidden: element.getAttribute('aria-hidden') };
      element.inert = true;
      element.setAttribute('aria-hidden', 'true');
      return state;
    });
  };

  BouquetBuilder.prototype.refreshDialogState = function () {
    var self = this;
    this.familyTabs.forEach(function (tab) {
      tab.setAttribute('aria-expanded', !self.isReviewing && tab.dataset.familyTab === self.activeFamily ? 'true' : 'false');
    });
    this.familySections.forEach(function (section) {
      var active = !self.isReviewing && section.dataset.familySection === self.activeFamily;
      if (active) {
        section.setAttribute('role', 'dialog');
        section.setAttribute('aria-modal', 'true');
      } else {
        section.removeAttribute('role');
        section.removeAttribute('aria-modal');
      }
    });
    if (this.summary) {
      if (this.isReviewing) {
        this.summary.setAttribute('role', 'dialog');
        this.summary.setAttribute('aria-modal', 'true');
      } else {
        this.summary.removeAttribute('role');
        this.summary.removeAttribute('aria-modal');
      }
    }
    this.setBackgroundInert(true);
  };

  BouquetBuilder.prototype.focusPickerStart = function (family) {
    var section = this.root.querySelector('[data-family-section="' + family + '"]');
    if (!section) return;
    section.scrollTop = 0;
    var firstControl = section.querySelector('[data-picker-back]') || section.querySelector('[data-close-picker]');
    window.requestAnimationFrame(function () {
      (firstControl || section).focus();
    });
  };

  BouquetBuilder.prototype.trapPickerFocus = function (event) {
    var section = this.isReviewing
      ? this.summary
      : this.root.querySelector('[data-family-section="' + this.activeFamily + '"]');
    if (!section) return;
    var focusable = Array.prototype.slice.call(section.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'))
      .filter(function (element) { return element.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (!section.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  BouquetBuilder.prototype.continueFromPicker = function (family) {
    if (this.selected[family].length !== this.requirement(family)) return;
    if (family === 'ranunculus') {
      this.setFamilyStage('anemone', true, false);
      this.lastPickerTrigger = this.familyTabs[1];
      this.refreshDialogState();
      this.focusPickerStart('anemone');
      return;
    }
    this.openReview(this.root.querySelector('[data-picker-next="anemone"]'));
  };

  BouquetBuilder.prototype.scrollToSummary = function () {
    this.openReview(this.mobileAction);
  };

  BouquetBuilder.prototype.handleMobileAction = function () {
    if (this.selected.ranunculus.length < 2) {
      this.openMobilePicker('ranunculus', this.familyTabs[0]);
    } else if (this.selected.anemone.length < this.requirement('anemone')) {
      this.openMobilePicker('anemone', this.familyTabs[1]);
    } else {
      this.scrollToSummary();
    }
  };

  BouquetBuilder.prototype.chooseTier = function (tier, shouldTrack) {
    if (tier !== 'classic' && tier !== 'premium') return;
    if (tier === 'classic' && !this.classicAvailable) return;
    if (tier === 'premium' && !this.premiumAvailable) return;
    var changed = this.tier !== tier;
    var previousSelectionCount = this.totalSelected();
    this.tier = tier;

    if (changed) {
      this.selected.ranunculus = [];
      this.selected.anemone = [];
      this.setFamilyStage('ranunculus', false, false);
      this.clearStatus();
    }

    if (shouldTrack) {
      track('bouquet_tier_selected', {
        tier: tier,
        bundle_price: (tier === 'premium' ? this.premiumPrice : this.classicPrice) / 100,
        upgrade_value: tier === 'premium' ? (this.premiumPrice - this.classicPrice) / 100 : 0,
        selections_restarted: changed && previousSelectionCount > 0
      });
    }

    this.persist();
    this.render();
  };

  BouquetBuilder.prototype.renderTier = function () {
    var self = this;
    this.tierTabs.forEach(function (tab) {
      var active = tab.dataset.tierTab === self.tier;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    this.tierPanels.forEach(function (panel) {
      panel.hidden = panel.dataset.tierPanel !== self.tier;
    });
    this.root.dataset.tier = this.tier;
  };

  BouquetBuilder.prototype.setFamilyStage = function (family, shouldTrack, shouldScroll) {
    this.activeFamily = family;
    this.familyTabs.forEach(function (tab) {
      var active = tab.dataset.familyTab === family;
      tab.classList.toggle('is-active', active);
    });
    this.familySections.forEach(function (section) {
      section.classList.toggle('is-active-stage', section.dataset.familySection === family);
    });

    if (shouldTrack) {
      track('bouquet_family_step_viewed', { flower_family: family });
    }

    if (shouldScroll && window.matchMedia('(max-width: 749px)').matches) {
      var section = this.root.querySelector('[data-family-section="' + family + '"]');
      if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  BouquetBuilder.prototype.totalRequired = function () {
    return 3;
  };

  BouquetBuilder.prototype.totalSelected = function () {
    return this.selected.ranunculus.length + this.selected.anemone.length;
  };

  BouquetBuilder.prototype.totalCorms = function () {
    var selectedCorms = this.selected.ranunculus.concat(this.selected.anemone).reduce(function (sum, item) {
      return sum + item.quantity;
    }, 0);

    return selectedCorms + (this.giftIncluded() ? this.giftQuantity : 0);
  };

  BouquetBuilder.prototype.isPremium = function () {
    return this.tier === 'premium';
  };

  BouquetBuilder.prototype.giftIncluded = function () {
    return this.isPremium() && this.isComplete();
  };

  BouquetBuilder.prototype.isComplete = function () {
    return this.selected.ranunculus.length === 2 &&
      this.selected.anemone.length === this.requirement('anemone');
  };

  BouquetBuilder.prototype.bundleKey = function () {
    if (!this.isComplete()) return null;
    var ids = this.selected.ranunculus.concat(this.selected.anemone).map(function (item) {
      return item.variantId;
    });
    if (this.isPremium()) ids.push(this.giftVariantId);
    return canonicalVariantKey(ids);
  };

  BouquetBuilder.prototype.resolveNativeBundle = function () {
    var key = this.bundleKey();
    var tierMap = this.nativeBundles[this.tier];
    if (!key || !tierMap) return null;
    var bundle = tierMap.get(key);
    if (!bundle) return null;
    var expectedPrice = this.isPremium() ? this.premiumPrice : this.classicPrice;
    if (bundle.price !== expectedPrice) return null;
    return bundle;
  };

  BouquetBuilder.prototype.findSelection = function (variantId) {
    var all = this.selected.ranunculus.concat(this.selected.anemone);
    return all.find(function (item) {
      return item.variantId === variantId;
    });
  };

  BouquetBuilder.prototype.cardData = function (card) {
    return {
      family: card.dataset.family,
      variantId: card.dataset.variantId,
      productId: card.dataset.productId,
      title: card.dataset.title,
      variantTitle: card.dataset.variantTitle,
      tier: card.dataset.tier || 'classic',
      quantity: Number(card.dataset.quantity) || 0,
      price: Number(card.dataset.price),
      image: card.dataset.image,
      exclusiveGroup: card.dataset.exclusiveGroup || ''
    };
  };

  BouquetBuilder.prototype.toggleCard = function (card) {
    var item = this.cardData(card);
    var familySelection = this.selected[item.family];
    var existingIndex = familySelection.findIndex(function (selected) {
      return selected.variantId === item.variantId;
    });

    this.clearStatus();

    if (existingIndex >= 0) {
      familySelection.splice(existingIndex, 1);
      if (item.family === 'ranunculus') {
        this.setFamilyStage('ranunculus', false, false);
      }
      track('bouquet_selection_removed', {
        flower_family: item.family,
        variant_id: item.variantId,
        product_name: item.title
      });
    } else {
      var incompatibleSelection = item.exclusiveGroup && familySelection.some(function (selected) {
        return selected.exclusiveGroup === item.exclusiveGroup;
      });
      if (incompatibleSelection) {
        this.setStatus('Choose one Aviv colour per mix, then pair it with any Elegance variety to keep the £6.99 upgrade.');
        this.pulseCount(item.family);
        return;
      }

      if (familySelection.length >= this.requirement(item.family)) {
        this.setStatus('You have chosen the maximum for this step. Remove one selected variety before choosing another.');
        this.pulseCount(item.family);
        return;
      }

      familySelection.push(item);
      track('bouquet_selection_added', {
        flower_family: item.family,
        variant_id: item.variantId,
        product_name: item.title,
        corm_count: item.quantity,
        selections_complete: this.totalSelected() === this.totalRequired()
      });
    }

    this.persist();
    this.render();
  };

  BouquetBuilder.prototype.persist = function () {
    try {
      window.sessionStorage.setItem(this.storageKey, JSON.stringify({
        tier: this.tier,
        variants: this.selected.ranunculus.concat(this.selected.anemone).map(function (item) {
          return item.variantId;
        })
      }));
    } catch (error) {
      return;
    }
  };

  BouquetBuilder.prototype.restore = function () {
    var saved;
    try {
      saved = JSON.parse(window.sessionStorage.getItem(this.storageKey));
    } catch (error) {
      return;
    }

    if (!saved || !Array.isArray(saved.variants)) return;
    this.tier = saved.tier === 'premium' && this.premiumAvailable ? 'premium' : 'classic';
    if (!this.classicAvailable && this.premiumAvailable) this.tier = 'premium';

    var self = this;
    saved.variants.forEach(function (variantId) {
      var card = self.cards.find(function (candidate) {
        return candidate.dataset.variantId === String(variantId) &&
          candidate.dataset.tier === self.tier &&
          !candidate.disabled;
      });
      if (!card) return;
      var item = self.cardData(card);
      if (self.selected[item.family].length < self.requirement(item.family)) {
        self.selected[item.family].push(item);
      }
    });
  };

  BouquetBuilder.prototype.pulseCount = function (family) {
    var element = family === 'ranunculus' ? this.ranCount : this.anemoneCount;
    if (!element || typeof element.animate !== 'function') return;
    element.animate([
      { transform: 'scale(1)' },
      { transform: 'scale(1.08)' },
      { transform: 'scale(1)' }
    ], { duration: 280 });
  };

  BouquetBuilder.prototype.progressCopy = function () {
    var ranRemaining = 2 - this.selected.ranunculus.length;
    var anemoneRemaining = this.requirement('anemone') - this.selected.anemone.length;

    if (this.isComplete()) {
      return this.isPremium() ? 'Your FREE Freesias are unlocked' : 'Your Classic mix is ready';
    }
    if (ranRemaining > 0) {
      return 'Pick ' + ranRemaining + ' more Ranunculus ' + (ranRemaining === 1 ? 'variety' : 'varieties');
    }
    return 'Pick ' + anemoneRemaining + ' more Anemone ' + (anemoneRemaining === 1 ? 'variety' : 'varieties');
  };

  BouquetBuilder.prototype.renderCards = function () {
    var self = this;
    this.cards.forEach(function (card) {
      card.hidden = card.disabled || card.dataset.tier !== self.tier;
      var selected = Boolean(self.findSelection(card.dataset.variantId));
      var familyAtLimit = self.selected[card.dataset.family].length >= self.requirement(card.dataset.family);
      var pairBlocked = !selected && card.dataset.exclusiveGroup && self.selected[card.dataset.family].some(function (item) {
        return item.exclusiveGroup === card.dataset.exclusiveGroup;
      });
      card.classList.toggle('is-selected', selected);
      card.classList.toggle('is-limit-blocked', familyAtLimit && !selected);
      card.classList.toggle('is-pair-blocked', Boolean(pairBlocked));
      card.setAttribute('aria-disabled', pairBlocked ? 'true' : 'false');
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  };

  BouquetBuilder.prototype.renderSelections = function () {
    var self = this;
    var items = this.selected.ranunculus.concat(this.selected.anemone);
    this.selectedList.innerHTML = '';

    if (!items.length) {
      var empty = document.createElement('p');
      empty.className = 'hb-bouquet__empty';
      empty.textContent = 'Your chosen varieties will appear here.';
      this.selectedList.appendChild(empty);
      return;
    }

    items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'hb-bouquet__selected-item';

      var image = document.createElement('img');
      image.src = item.image;
      image.alt = '';
      image.loading = 'lazy';

      var copy = document.createElement('div');
      var title = document.createElement('strong');
      title.textContent = item.title;
      var meta = document.createElement('small');
      meta.textContent = item.variantTitle + ' · ' + money(item.price) + ' value';
      copy.appendChild(title);
      copy.appendChild(meta);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.removeVariant = item.variantId;
      remove.setAttribute('aria-label', 'Remove ' + item.title);
      remove.textContent = '×';

      row.appendChild(image);
      row.appendChild(copy);
      row.appendChild(remove);
      self.selectedList.appendChild(row);
    });
  };

  BouquetBuilder.prototype.displayTitle = function (item) {
    return item.title
      .replace(/^Ranunculus\s+/i, '')
      .replace(/^Anemone\s+/i, '')
      .replace(/\s+\(Garden Anemone\)$/i, '');
  };

  BouquetBuilder.prototype.createPick = function (item, fallbackLabel, includeMeta) {
    var pick = document.createElement('span');
    pick.className = item ? 'hb-bouquet__pick is-filled' : 'hb-bouquet__pick';

    if (!item) {
      pick.textContent = fallbackLabel;
      return pick;
    }

    var image = document.createElement('img');
    image.src = item.image;
    image.alt = '';
    image.loading = 'lazy';
    pick.appendChild(image);

    var copy = document.createElement('span');
    var title = document.createElement('strong');
    title.textContent = this.displayTitle(item);
    copy.appendChild(title);
    if (includeMeta) {
      var meta = document.createElement('small');
      meta.textContent = item.variantTitle;
      copy.appendChild(meta);
    }
    pick.appendChild(copy);
    return pick;
  };

  BouquetBuilder.prototype.renderFamilyPicks = function (family) {
    var selected = this.selected[family];
    var required = this.requirement(family);
    var mainTarget = this.mobileFamilyPicks[family];
    var pickerTarget = this.pickerPicks[family];

    if (mainTarget) mainTarget.innerHTML = '';
    if (pickerTarget) pickerTarget.innerHTML = '';

    for (var index = 0; index < required; index += 1) {
      var item = selected[index];
      var label = family === 'ranunculus' ? 'Ranunculus ' + (index + 1) : 'Anemone ' + (index + 1);
      if (mainTarget) mainTarget.appendChild(this.createPick(item, label, false));
      if (pickerTarget) pickerTarget.appendChild(this.createPick(item, 'Pick ' + (index + 1), true));
    }
  };

  BouquetBuilder.prototype.renderPickerControls = function () {
    var self = this;
    var ranComplete = this.selected.ranunculus.length === 2;
    var tierName = this.isPremium() ? 'Premium' : 'Classic';
    if (this.familyTitles.ranunculus) this.familyTitles.ranunculus.textContent = 'Choose 2 ' + tierName + ' Ranunculus';
    if (this.familyTitles.anemone) {
      this.familyTitles.anemone.textContent = 'Choose 1 ' + tierName + ' Anemone';
    }

    this.familyTabs.forEach(function (tab) {
      var family = tab.dataset.familyTab;
      if (family === 'anemone') tab.disabled = !ranComplete;
    });

    this.familyTabStatuses.forEach(function (status) {
      var family = status.dataset.familyTabStatus;
      var count = self.selected[family].length;
      var required = self.requirement(family);
      if (family === 'anemone' && !ranComplete) {
        status.textContent = 'Choose Ranunculus first';
      } else {
        status.textContent = count + ' of ' + required + ' ' + (required === 1 ? 'variety' : 'varieties') + ' chosen';
      }
    });

    this.familyActions.forEach(function (action) {
      var family = action.dataset.familyAction;
      var count = self.selected[family].length;
      action.textContent = count ? 'Edit' : 'Choose';
    });

    this.pickerNextButtons.forEach(function (button) {
      var family = button.dataset.pickerNext;
      var count = self.selected[family].length;
      var required = self.requirement(family);
      var remaining = required - count;
      var ready = remaining === 0;
      button.disabled = !ready;
      button.textContent = ready
        ? (family === 'ranunculus' ? 'Continue to Anemones' : 'Done — review my mix')
        : 'Choose ' + remaining + ' more ' + (remaining === 1 ? 'variety' : 'varieties');
      if (self.pickerStatuses[family]) {
        self.pickerStatuses[family].textContent = count + ' of ' + required + ' selected' + (ready ? ' · Ready' : '');
      }
    });
  };

  BouquetBuilder.prototype.renderValue = function () {
    var complete = this.isComplete();
    var fixedPrice = this.isPremium() ? this.premiumPrice : this.classicPrice;
    var selectedValue = this.selected.ranunculus.concat(this.selected.anemone).reduce(function (sum, item) {
      return sum + item.price;
    }, 0);
    var normalValue = selectedValue + (this.giftIncluded() ? this.giftPrice : 0);
    var saving = normalValue - fixedPrice;

    this.bundlePrice.textContent = money(fixedPrice);
    this.mobilePrice.textContent = money(fixedPrice);
    this.normalValue.textContent = complete ? money(normalValue) : '—';
    this.saving.textContent = complete ? 'SAVE ' + money(Math.max(0, saving)) : 'Complete your mix';

    this.root.dataset.currentNormalValue = normalValue;
    this.root.dataset.currentSaving = complete ? Math.max(0, saving) : 0;
  };

  BouquetBuilder.prototype.render = function () {
    var total = this.totalSelected();
    var required = this.totalRequired();
    var complete = this.isComplete();
    var nativeBundle = complete ? this.resolveNativeBundle() : null;
    var purchaseReady = complete && this.checkoutEnabled && nativeBundle && nativeBundle.available && !this.isSubmitting;
    var progress = Math.min(100, Math.round((total / required) * 100));

    this.renderTier();
    this.renderCards();
    this.renderSelections();
    this.renderFamilyPicks('ranunculus');
    this.renderFamilyPicks('anemone');
    this.renderPickerControls();
    this.renderValue();

    this.progressLabel.textContent = total + ' of ' + required + ' varieties chosen';
    this.progressBar.style.width = progress + '%';
    this.progressMessage.textContent = this.progressCopy();
    this.ranCount.textContent = this.selected.ranunculus.length + ' / 2 varieties';
    this.anemoneCount.textContent = this.selected.anemone.length + ' / ' + this.requirement('anemone') + ' ' + (this.requirement('anemone') === 1 ? 'variety' : 'varieties');
    this.ranCount.classList.toggle('is-complete', this.selected.ranunculus.length === 2);
    this.anemoneCount.classList.toggle('is-complete', this.selected.anemone.length === this.requirement('anemone'));
    this.anemoneRequired.textContent = this.requirement('anemone');
    this.anemoneVarietyLabel.textContent = this.requirement('anemone') === 1 ? 'variety' : 'varieties';

    this.summaryTier.textContent = complete
      ? this.totalCorms() + '-corm ' + (this.isPremium() ? 'Premium flower mix' : 'Classic flower mix')
      : 'Your chosen varieties';
    this.summaryCount.textContent = total + ' / ' + required;
    this.gift.hidden = !this.isPremium();
    this.gift.classList.toggle('is-locked', !complete);
    this.giftStatus.textContent = complete ? 'Gift unlocked' : 'Free when your Premium mix is complete';

    var bundlePrice = this.isPremium() ? this.premiumPrice : this.classicPrice;
    var hasFreeDelivery = bundlePrice >= 4000;
    this.deliveryStatus.classList.toggle('is-free', hasFreeDelivery);
    this.deliveryStatus.querySelector('span').textContent = hasFreeDelivery
      ? 'Free standard delivery unlocked'
      : (this.isPremium() ? 'Premium' : 'Classic') + ' mix is below the £40 free-delivery threshold';
    if (this.premiumSwitch) this.premiumSwitch.hidden = !this.premiumAvailable || this.isPremium() || !complete;

    this.cta.disabled = !purchaseReady;
    this.cta.classList.toggle('is-loading', this.isSubmitting);
    if (this.isSubmitting) {
      this.ctaLabel.textContent = 'Adding your flower mix…';
    } else if (!complete) {
      this.ctaLabel.textContent = 'Pick ' + (required - total) + ' more ' + (required - total === 1 ? 'variety' : 'varieties') + ' to unlock';
    } else if (!this.checkoutEnabled) {
      this.ctaLabel.textContent = 'Checkout is not available in this preview';
    } else if (!nativeBundle) {
      this.ctaLabel.textContent = 'This combination is temporarily unavailable';
    } else if (!nativeBundle.available) {
      this.ctaLabel.textContent = 'This combination has just sold out';
    } else {
      this.ctaLabel.textContent = 'Add ' + (this.isPremium() ? 'Premium' : 'Classic') + ' mix · ' + money(this.isPremium() ? this.premiumPrice : this.classicPrice);
    }

    this.mobileProgress.textContent = complete
      ? (this.isPremium() ? 'Freesias unlocked' : 'Classic mix ready') + ' · Save ' + money(Number(this.root.dataset.currentSaving))
      : total + ' of ' + required + ' varieties chosen';
    this.mobileBar.classList.toggle('is-complete', complete);
    if (complete) this.mobileAction.textContent = 'Review your mix';
    else if (this.selected.ranunculus.length < 2) this.mobileAction.textContent = 'Choose Ranunculus';
    else this.mobileAction.textContent = 'Choose Anemone';
  };

  BouquetBuilder.prototype.clearStatus = function () {
    this.status.textContent = '';
  };

  BouquetBuilder.prototype.setStatus = function (message) {
    this.status.textContent = message;
  };

  BouquetBuilder.prototype.submit = async function () {
    if (!this.isComplete() || this.isSubmitting) return;

    var bundle = this.resolveNativeBundle();
    var fixedPrice = this.isPremium() ? this.premiumPrice : this.classicPrice;
    var componentIds = this.selected.ranunculus.concat(this.selected.anemone).map(function (item) {
      return Number(item.variantId);
    });
    if (this.isPremium()) componentIds.push(Number(this.giftVariantId));

    track('bouquet_builder_complete', {
      tier: this.tier,
      bundle_price: fixedPrice / 100,
      normal_value: Number(this.root.dataset.currentNormalValue) / 100,
      saving: Number(this.root.dataset.currentSaving) / 100,
      total_corms: this.totalCorms(),
      component_variant_ids: componentIds,
      bundle_variant_id: bundle ? bundle.id : null
    });

    if (!this.checkoutEnabled) {
      this.setStatus('Checkout is not enabled for this preview. No products were added.');
      return;
    }
    if (!bundle || !bundle.available) {
      this.setStatus('This exact flower mix is no longer available. Please change one of your varieties.');
      this.render();
      return;
    }

    this.isSubmitting = true;
    this.clearStatus();
    this.render();
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    var sections = getCartSections();
    track('bouquet_add_started', {
      tier: this.tier,
      bundle_variant_id: bundle.id,
      bundle_price: fixedPrice / 100,
      component_variant_ids: componentIds
    });

    var payload;
    try {
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: bundle.id, quantity: 1 }],
          sections: sections.map(function (section) { return section.id; }),
          sections_url: window.location.pathname
        })
      });
      payload = await response.json();
      if (!response.ok || payload.status === 422) {
        throw new Error(payload.description || payload.message || 'This flower mix could not be added. Please try again.');
      }
    } catch (error) {
      this.isSubmitting = false;
      this.render();
      this.setStatus(error && error.message ? error.message : 'This flower mix could not be added. Please try again.');
      track('bouquet_add_error', {
        tier: this.tier,
        bundle_variant_id: bundle.id,
        error_message: String(error && error.message ? error.message : 'unknown').slice(0, 180)
      });
      console.error('[HB flower mix] Add failed:', error);
      return;
    }

    try {
      var cart = await getCart(root);
      var addedLine = Array.isArray(cart.items) && cart.items.find(function (item) {
        return Number(item.variant_id || item.id) === bundle.id;
      });
      if (!addedLine) throw new Error('The added flower mix could not be confirmed in the refreshed basket.');

      var refreshedSections = refreshCartSections(payload, sections);
      updateCartCount(cart);
      this.isSubmitting = false;
      this.render();
      this.setStatus('Your flower mix has been added to the basket.');
      track('bouquet_added', {
        tier: this.tier,
        bundle_variant_id: bundle.id,
        bundle_price: fixedPrice / 100,
        cart_item_count: cart.item_count,
        cart_total: cart.total_price / 100,
        component_variant_ids: componentIds
      });
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
      this.closeMobilePicker(false);
      if (!(await openMiniCart(refreshedSections === 0))) window.location.assign(root + 'cart');
    } catch (error) {
      this.isSubmitting = false;
      this.render();
      this.setStatus('Your flower mix was added. Opening your basket…');
      track('bouquet_post_add_refresh_error', {
        tier: this.tier,
        bundle_variant_id: bundle.id,
        error_message: String(error && error.message ? error.message : 'unknown').slice(0, 180)
      });
      console.warn('[HB flower mix] Added successfully, but the basket UI could not be refreshed:', error);
      window.location.assign(root + 'cart');
    }
  };

  function init(container) {
    var scope = container || document;
    Array.prototype.slice.call(scope.querySelectorAll(ROOT_SELECTOR)).forEach(function (root) {
      if (root.dataset.bouquetInitialized === 'true') return;
      root.dataset.bouquetInitialized = 'true';
      new BouquetBuilder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (window.__HB_BOUQUET_TEST__) {
    window.HBDesignBouquetTest = {
      BouquetBuilder: BouquetBuilder,
      canonicalVariantKey: canonicalVariantKey,
      readNativeBundleMap: readNativeBundleMap,
      openMiniCart: openMiniCart
    };
  }
})();
